import client from "./client";

// ── Exams ──
export const getExams = async (params = {}) => {
  const {data} = await client.get("/exams/", {params});
  return data;
};

export const getExamsAdmin = async (params = {}) => {
  const {data} = await client.get("/exams/", {
    params: {...params, include_inactive: 1},
  });
  return data;
};

export const getExam = async (examId) => {
  const {data} = await client.get(`/exams/${examId}/`);
  return data;
};

export const getExamAdmin = async (examId) => {
  const {data} = await client.get(`/exams/${examId}/`, {
    params: {include_inactive: 1},
  });
  return data;
};

export const createExam = async (payload) => {
  const {data} = await client.post("/exams/", payload);
  return data;
};

export const updateExam = async (examId, payload) => {
  const {data} = await client.put(`/exams/${examId}/`, payload);
  return data;
};

export const deleteExam = async (examId) => {
  await client.delete(`/exams/${examId}/`);
};

// ── Writing Questions ──
export const addWritingQuestion = async (examId, payload) => {
  const {data} = await client.post(`/exams/${examId}/questions/`, payload);
  return data;
};

export const updateWritingQuestion = async (examId, questionId, payload) => {
  const {data} = await client.put(
    `/exams/${examId}/questions/${questionId}/`,
    payload,
  );
  return data;
};

export const deleteWritingQuestion = async (examId, questionId) => {
  await client.delete(`/exams/${examId}/questions/${questionId}/`);
};

// ── Speaking Parts ──
export const addSpeakingPart = async (examId, payload) => {
  const {data} = await client.post(`/exams/${examId}/speaking/`, payload);
  return data;
};

export const updateSpeakingPart = async (examId, partId, payload) => {
  const {data} = await client.put(
    `/exams/${examId}/speaking/${partId}/`,
    payload,
  );
  return data;
};

export const deleteSpeakingPart = async (examId, partId) => {
  await client.delete(`/exams/${examId}/speaking/${partId}/`);
};

// ── Reading Parts ──
export const updateReadingPart = async (examId, partNumber, content) => {
  const {data} = await client.put(`/exams/${examId}/reading/${partNumber}/`, {
    content,
  });
  return data;
};

export const importGeneralWritingExam = async ({exam_id, payload}) => {
  const body = exam_id ? {exam_id, payload} : {payload};
  const {data} = await client.post("/exams/general-writing-import/", body);
  return data;
};

// ── Attempts ──
export const createAttempt = async (
  examId,
  mode = "practice",
  section = "",
) => {
  const {data} = await client.post("/attempts/", {
    exam_id: examId,
    mode,
    section,
  });
  return data;
};

export const getAttempt = async (attemptId) => {
  const {data} = await client.get(`/attempts/${attemptId}/`);
  return data;
};

export const submitWriting = async (attemptId, responses) => {
  const {data} = await client.post(`/attempts/${attemptId}/writing/`, {
    responses,
  });
  return data;
};

export const submitSpeaking = async (attemptId, transcript) => {
  const {data} = await client.post(`/attempts/${attemptId}/speaking/`, {
    transcript,
  });
  return data;
};

export const speakingChat = async (attemptId, messages) => {
  const {data} = await client.post(`/attempts/${attemptId}/speaking/chat/`, {
    messages,
  });
  return data;
};

export const submitReading = async (attemptId, answers) => {
  const {data} = await client.post(`/attempts/${attemptId}/reading/`, {
    answers,
  });
  return data;
};

export const completeAttempt = async (attemptId) => {
  const {data} = await client.post(`/attempts/${attemptId}/complete/`);
  return data;
};

export const getMyAttempts = async () => {
  const {data} = await client.get("/users/me/attempts/");
  return data;
};

// ── Polling helper ──
export const pollAttemptUntilMarked = (
  attemptId,
  onUpdate,
  onError,
  intervalMs = 3000,
) => {
  let failureCount = 0;
  const startedAt = Date.now();
  const maxPollMs = 60000;
  const timer = setInterval(async () => {
    try {
      const attempt = await getAttempt(attemptId);
      failureCount = 0;
      onUpdate(attempt);
      const allDone = [
        ...attempt.writing_responses,
        ...attempt.speaking_responses,
      ].every((r) => r.mark_status === "done" || r.mark_status === "failed");
      if (allDone) clearInterval(timer);
      if (!allDone && Date.now() - startedAt >= maxPollMs) {
        clearInterval(timer);
        onError?.(new Error("Polling timed out."));
      }
    } catch (error) {
      failureCount += 1;
      if (failureCount >= 3) {
        clearInterval(timer);
        onError?.(error);
      }
    }
  }, intervalMs);
  return () => clearInterval(timer);
};
